export * from './visit-details.module';
export * from './visit-details.component';
